import { trim, isUndefined } from "lodash";

export const isItemSelected = (state, resourcesListKey, itemId, itemType) => {
  if (isUndefined(itemId)) return false;

  const { selection } = state.resourcesList[resourcesListKey];
  const selectedItemId = selection.itemId;
  const selectedItemType = selection.itemType;

  return selectedItemId === itemId && selectedItemType === itemType;
};

// Updated version of the isItemSelected helper to take a `resourcesList` as input, since
// we now use the `useResourcesList` hook instead of directly manipulatinf the redux root
// state in the app code.
//
export const isResourcesListItemSelected = (resourcesList, { id, type }) => {
  // Handle the case of a component that checks for the selected state of an item but is
  // rendered outside of a ResourcesListProvider, so gets a `null` resourcesList from
  // the `useResourcesList` hook.
  if (!resourcesList.selection) return false;

  const { itemId, itemType } = resourcesList.selection;

  return itemId === id && itemType === type;
};

export const selectedItemId = (state, resourcesListKey, itemType) => {
  const { selection } = state.resourcesList[resourcesListKey];
  const selectedItemId = selection.itemId;
  const selectedItemType = selection.itemType;

  if (selectedItemType === itemType) {
    return selectedItemId;
  }
};

export const selectedItem = (stateOrResourceList, resourcesListKey) => {
  const selection =
    stateOrResourceList.selection ||
    stateOrResourceList.resourcesList[resourcesListKey].selection;
  const { itemId, itemType } = selection;

  return { itemId, itemType };
};

// Returns wether the provided `resourcesList` redux state object is filtered or not
//
export const isResourcesListFiltered = ({ search }) => {
  const { terms, selectedThemes, bookmarkedOnly, mineOnly } = search;

  return trim(terms) !== "" || selectedThemes?.length > 0 || bookmarkedOnly || mineOnly;
};

export const isResourceFilteredIn = (search, resource) => {
  const { selectedThemes, bookmarkedOnly, mineOnly } = search;

  if (selectedThemes.length) {
    const hasSelectedTheme = selectedThemes.some(selectedTheme =>
      resource.themes?.some(({ id }) => id == selectedTheme.id)
    );

    if (!hasSelectedTheme) return false;
  }

  if (bookmarkedOnly && !resource.isBookmarked) return false;
  if (mineOnly && !resource.isMine) return false;

  return true;
};
